export default {
  addDescription: '+ اضافه کردن توضیحات بیشتر',
  aQuestoinCouldNotBeDistinctiveAndMultiSelectAtSameTime:
    'یک سوال نمی‌تواند هم متمایز باشد و هم چند پاسخه',
  answerRequiredLabel: 'آیا پاسخ دادن به این سؤال الزامیست؟',
  distinctiveLabel: 'متمایز کردن سؤال',
  showInTitleLabel: 'نمایش در عنوان / قابلیت فیلتر',
  distinctiveHint:
    'در صورتی که یک سؤال متمایزکننده باشد، از ارسال پاسخ تکراری جلوگیری می‌کند.',
  enterQuestionTag:
    'لطفاً برچسب‌هایی که می‌خواهید این سؤال با آن مشخص گردد را مشخص کنید:',
  enterTags:
    'لطفا برچسب‌های که می‌خواهید پاسخ مربوط به این پرسش‌نامه با آن مشخص گردد، را مشخص کنید.',
  questionFieldName: 'عنوان',
  questionFieldValue: 'محتوا',
  questionHintLabel: 'راهنما',
  questionHintPlaceholder: 'راهنمای پاسخ به سؤال',
  questionTitleLabel: 'سؤال',
  questionTitlePlaceholder: 'متن سؤال',
  selectTag: 'انتخاب برچسب',
  selectValue: 'انتخاب مقدار',
  unifyValueAndText: 'استفاده از شناسه‌ی معادل با متن',
  unifyValueAndTextHint:
    'در صورتی که می‌خواهید در چند سؤال یا پرسش‌نامه از گزینه‌های مشترک و با قابلیت گزارش‌گیری استفاده کنید این گزینه را فعال کنید. و در غیر این صورت به هیچ عنوان این گزینه را فعال نکنید. در صورت فعال بود این گزینه تغییر در عنوان پاسخ باعث اختلال در پاسخ های قبلی می‌شود.',
  useKeepUnique:
    'برای استفاده از سؤالات متمایزکننده، در تنظیمات پرسش‌نامه گزینه‌ی پاسخ‌ها یکتا باشد را فعال کنید.',
  questionWeight: 'وزن سؤال',
  questionPlaceholder: 'وزن سؤال را وارد کنید',
  conditionalView: 'نمایش سوال با توجه به سوال دیگر',
  refQuestion: 'سوال مرتبط',
  questionValues: 'مقادیری که به ازای آن این سوال نمایش داده شود',
  protection: 'محافظت شده',
  protection_View: 'فقط به کاربر با دسترسی گزارش نمایش داده شود',
  protection_Edit: 'فقط کاربر با دسترسی تغییر داده بتواند ویرایش کند',
  protection_null: 'محافظت نشده',
  showInTitleDesc:
    'با فعال شدن این ویژگی پاسخ این سوال در لیست پاسخ ها جهت مشاهده و فیلتر نمایش داده خواهد شد',
  addRole: 'افزودن سمت',
  anyRole: 'بدون محدودیت نقش',
  editableWith: 'سمت‌هایی که امکان ویرایش این سوال را دارند',
  viewableWith: 'سمت‌هایی که امکان مشاهده این سوال را دارند',
  advancedOptions: 'تنظیمات پیشرفته',
  hintTagsAndDesc: 'توضیحات / برچسب‌ها / فیلد‌ها',
  hint: 'توضیحات',
  senderWhileSending: 'ارسال کننده پاسخ در هنگام ارسال',
  senderWhileUpdating: 'ارسال کننده پاسخ در هنگام به‌روز رسانی',
  deleted: '(حذف شده)',
  enable: 'فعال',
  availableQuestionFieldConfigs:
    'کانفیگ های موجود : conf_addDescriptionTitle, conf_dataSourceField, conf_dataSourceConvertDateFormat , conf_useAsEffectiveDate , conf_randomDataOnMissing , conf_hidden',
};
